import './Home.scss';

import React, { useEffect, useState } from 'react';
import { scrollToSection } from '../components/Header';
import { Award, Phone, Shield, Sparkle } from '../components/Icons';
import { heroPhotos } from '../data/projects';

const heroImages = heroPhotos.map((p) => p.src);
const HERO_INTERVAL = 7000;

const strip = ['Residential painting', 'Strata & commercial', 'Kitchen cabinets', 'Licensed & insured'];

const d = (ms: number) => ({ '--delay': `${ms}ms` } as React.CSSProperties);

export function Home() {
  const [slide, setSlide] = useState(0);

  useEffect(() => {
    heroImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
    const timer = window.setInterval(() => setSlide((i) => (i + 1) % heroImages.length), HERO_INTERVAL);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <>
      <section id="home" className="hero on-dark">
        <div className="hero__bg" role="presentation">
          {heroImages.map((src, i) => (
            <div key={src} className={`hero__slide${i === slide ? ' is-active' : ''}`} style={{ backgroundImage: `url(${src})` }} />
          ))}
        </div>
        <div className="hero__veil" />

        <div className="container hero__inner">
          <span className="hero__eyebrow reveal" style={d(60)}>
            Professional <i /> Reliable <i /> Local
          </span>
          <h1 className="reveal" style={d(140)}>
            Delta's #1 Full Service <br /> Painting Company.
          </h1>
          <p className="hero__sub reveal" style={d(240)}>
            Interior, exterior, cabinet, strata and commercial painting for homes and businesses across the Lower
            Mainland. Over a decade of clean lines and happy customers.
          </p>
          <div className="hero__badges reveal" style={d(320)}>
            <span className="badge badge--glass">
              <Award /> 10+ Years Experience
            </span>
            <span className="badge badge--glass">
              <Shield /> $5M Insured
            </span>
            <span className="badge badge--glass">
              <Sparkle /> 3-Year Guarantee
            </span>
          </div>
          <div className="hero__cta reveal" style={d(400)}>
            <button className="btn btn--blue" onClick={() => scrollToSection('contact')}>
              Get a free quote
            </button>
            <a className="btn btn--glass" href="tel:+16043655225">
              <Phone /> (604) 365-5225
            </a>
          </div>
        </div>

        <div className="hero__dots" aria-hidden="true">
          {heroImages.map((src, i) => (
            <button key={src} className={i === slide ? 'is-active' : ''} onClick={() => setSlide(i)} tabIndex={-1} />
          ))}
        </div>
      </section>

      <div className="strip">
        <div className="container strip__inner">
          {strip.map((s) => (
            <span key={s}>{s}</span>
          ))}
        </div>
      </div>
    </>
  );
}
